import { ServerEditableType } from 'QuoteApp/utils/contexts';
import {
  AddressCategoryType,
  AddressFieldsType,
  FormValuesType,
} from '../GetDetails';
import { transformSaveDriversRequest } from '../PostSaveDrivers';
import { transformSaveVehiclesRequest } from '../PostSaveVehicles';
import { sanitizeNumString, sanitizeString } from '../utils';
import {
  ServerContactInfoRequestType,
  ServerEffectiveDateRequestType,
  ServerEntitiesRequestType,
} from './types';

export const transformEntitiesRequest = (data: {
  values: FormValuesType;
  initialValues: FormValuesType;
  editableFields: Required<ServerEditableType>;
  maskedFields: Required<ServerEditableType>;
}): ServerEntitiesRequestType => {
  const { values, initialValues, editableFields, maskedFields } = data;

  return {
    ...transformSaveDriversRequest({
      values: values.drivers,
      initialValues: initialValues.drivers,
      editableFields: editableFields.drivers,
      maskedFields: maskedFields.drivers,
    }),
    ...transformSaveVehiclesRequest({
      values: values.vehicles,
      editableFields: editableFields.vehicles,
    }),
  };
};

export const transformSavePolicyContactInfo = (
  values: FormValuesType
): ServerContactInfoRequestType => {
  const residencyAddress = values.address[values.primaryDriverId];
  const mailingAddress = values.mailingAddress[values.primaryDriverId];

  const { phoneType, phoneNumber, email } = values.contactInfo[
    values.primaryDriverId
  ];

  function mapAddressType(
    address: AddressFieldsType,
    addressCategory: AddressCategoryType
  ): ServerContactInfoRequestType['addresses'][number] {
    return {
      identifier: address.identifier,
      addressLine1: sanitizeString(address.address1),
      addressLine2: sanitizeString(address.address2),
      city: sanitizeString(address.city),
      state: sanitizeString(address.state),
      postalCode: sanitizeString(address.zip),
      addressType: addressCategory,
    };
  }

  return {
    insurableParties: [
      {
        identifier: values.primaryDriverId,
        contactInformation: {
          telephone: {
            phoneType: sanitizeString(phoneType),
            number: sanitizeNumString(phoneNumber),
          },
          email: sanitizeString(email),
        },
      },
    ],
    addresses: [
      mapAddressType(residencyAddress, 'residency'),
      mapAddressType(mailingAddress, 'mailing'),
    ],
  };
};

export const transformSaveEffectiveDateRequest = (
  data: string
): ServerEffectiveDateRequestType => {
  return {
    insuranceProducts: [
      { policyTerm: { effectiveDate: data }, productType: 'personalAuto' },
    ],
  };
};
